import React from "react";
import {
  TextInput,
  Edit,
  CardActions,
  RefreshButton,
  ListButton,
  SimpleForm,
  DisabledInput,
  DateInput,
  TextField,
  ReferenceField,
  ReferenceInput,
  SelectInput
} from "react-admin";
import { ToolbarSave } from "../toolbarSave";

export class PesajeComentarioEditComponent extends React.Component {
  render() {
    const props = this.props;
    return (
      <Edit
        title={<span>Editar Peso</span>}
        actions={
          <CardActions>
            <RefreshButton />
            <ListButton />
          </CardActions>
        }
        {...props}
      >
        <SimpleForm toolbar={<ToolbarSave {...props} />}>
          <PesadorNombre />
          <ReferenceField label="Predio" source="predio" reference="predios">
            <TextField source="nombre" />
          </ReferenceField>
          <DateInput label="fecha" source="fecha" locales="es-AR" />
          {this.props.pesadorNombre}
          <DisabledInput label="Recuperador" source="cartoneroNombre" />
          <DisabledInput label="Etapa" source="etapa" />
          <DisabledInput label="Número de bolsón" source="bolson" />
          <TextInput label="Peso (Kgs.)" source="peso" />
          <TextInput label="Comentario" source="comentario" />
          <TextInput label="Camión" source="camion" />
          <ReferenceInput
            label="Material"
            reference="materiales"
            source="material"
            filter={{enPesajes: true}}
            sort={{ field: 'nombre', order: 'ASC' }}
          >
            <SelectInput optionText="nombre" optionValue="_id" fullWidth />
          </ReferenceInput>
        </SimpleForm>
      </Edit>
    );
  }
}

export const PesadorNombre = props => {
  const { record } = props;
  return (
    <h3>
      Pesado por:{" "}
      {record.pesadorNombre
        ? record.pesadorNombre
        : "No se tiene informacion sobre el pesador"}
    </h3>
  );
};



// WEBPACK FOOTER //
// ./src/components/Pesajes/PesajeComentarioEditComponent.js